// extracted by mini-css-extract-plugin
export default {"box":"ShipmentDestination_box__TzZGM","header":"ShipmentDestination_header__HSCHW","source":"ShipmentDestination_source__0hewx"};